// extracted by mini-css-extract-plugin
module.exports = {"subNavPlaceholder":"purify_sub-nav__subNavPlaceholder--3da7u","mobileSubnav":"purify_sub-nav__mobileSubnav--hhs60","desktopSubnav":"purify_sub-nav__desktopSubnav--21w6A"};